<template>
	<li style="z-index: 0;">
		<div class="bk-book book" :style="'width: '+Data.width+'px;'">
			<div class="bk-front" :style="'width: '+Data.width+'px;'">
				<div class="bk-cover-back" :style="'width: '+Data.width+'px;'"></div>
				<div class="bk-cover" :style="'width: '+Data.width+'px;'">
					<img
						:src="Data.coverImg"
						:alt="Data.title+' KAPAK RESMİ'"
						v-show="Data.coverImg"
						:width="Data.width+'px'"
						:height="Data.height+'px'"/>
				</div>
			</div>

			<div class="bk-page" :style="'width: '+Data.width+'px;'">
				<div class="bk-content bk-content-current"></div>
			</div>

			<div class="bk-back" :style="'width: '+Data.width+'px;'">
				<img
					:src="Data.backCoverImg"
					:alt="Data.title+' ARKA KAPAK RESMİ'"
					v-show="Data.backCoverImg"
					:height="Data.height+'px'"
					:width="Data.width+'px'"/>
			</div>

			<div class="bk-right" :style="'width: '+Data.thickness+'px;'"></div>
			
			<div class="bk-left" :style="'width: '+Data.thickness+'px;'">
				<img
					:src="Data.leftImg"
					:alt="Data.title+' CİLT RESMİ'"
					v-show="Data.leftImg"
					:height="Data.height+'px'">
			</div>
			
			<div class="bk-top"></div>
			
			<div class="bk-bottom"></div>
		</div>

		<div v-show="!isHide" :style="{'position': 'relative', 'margin-top': '200px'}">
			<span class="tag"></span>
		</div>
	</li>
</template>

<script>
	export default {
		name: 'Book',

		data() {
			return {
				isHide: true,
			}
		},

		props: {
			Data:	{ type: Object,	required: true,	}
		},
	}
</script>

<style scoped>
	li {
		position: relative;
		width: 300px;
		float: left;
		z-index: 1;
		margin: 0 15px 450px 0;
		-webkit-perspective: 1800px;
		perspective: 1800px;
		cursor: pointer;
	}

	li:last-child {
		margin-right: 0;
	}

	li .bk-book {
		position: absolute;
		width: 100%;
		height: 400px;
		-webkit-transform-style: preserve-3d;
		transform-style: preserve-3d;
		-webkit-transition: -webkit-transform .5s;
		transition: transform .5s;
	}

	li .bk-book:hover, .bk-bookdefault:hover {
		transition: transform .5s;
		-webkit-transform: rotate3d(0,1,0,60deg);
		-ms-transform: rotate3d(0,1,0,60deg);
		transform: rotate3d(0,1,0,60deg);
	}

	li .bk-book > div,
	li .bk-front > div {
		display: block;
		position: absolute;
	}

	li .bk-front {
		-webkit-transform-style: preserve-3d;
		transform-style: preserve-3d;
		-ms-transform-origin: 0% 50%;
		-webkit-transform-origin: 0% 50%;
		transform-origin: 0% 50%;
		-webkit-transition: -webkit-transform .5s;
		transition: transform .5s;
		-webkit-transform: translate3d(0,0,20px);
		-ms-transform: translate3d(0,0,20px);
		transform: translate3d(0,0,20px);
		z-index: 10;
	}

	li .bk-front > div {
		z-index: 1;
		-webkit-backface-visibility: hidden;
		backface-visibility: hidden;
		-webkit-transform-style: preserve-3d;
		transform-style: preserve-3d;
	}

	li .bk-page {
		-webkit-transform: translate3d(0,0,19px);
		-ms-transform: translate3d(0,0,19px);
		transform: translate3d(0,0,19px);
		display: none;
		width: 295px;
		height: 390px;
		top: 5px;
		-webkit-backface-visibility: hidden;
		backface-visibility: hidden;
		z-index: 9;
	}

	li .bk-front,
	li .bk-back,
	li .bk-front > div {
		width: 300px;
		height: 400px;
	}

	li .bk-left,
	li .bk-right {
		width: 40px;
		left: -20px;
	}

	li .bk-top,
	li .bk-bottom {
		width: 295px;
		height: 40px;
		top: -15px;
		-webkit-backface-visibility: hidden;
		backface-visibility: hidden;
	}

	li .bk-back {
		-webkit-transform: rotate3d(0,1,0,-180deg) translate3d(0,0,20px);
		transform: rotate3d(0,1,0,-180deg) translate3d(0,0,20px);
		box-shadow: 10px 10px 30px rgba(0,0,0,0.3);
		border-radius: 3px 0 0 3px;
	}

	li .bk-cover-back {
		background-color: #000;
		-ms-transform: rotate3d(0,1,0,-179deg);
		-webkit-transform: rotate3d(0,1,0,-179deg);
		transform: rotate3d(0,1,0,-179deg);
	}

	li .bk-right {
		height: 390px;
		top: 5px;
		-ms-transform: rotate3d(0,1,0,90deg) translate3d(0,0,295px);
		-webkit-transform: rotate3d(0,1,0,90deg) translate3d(0,0,295px);
		-moz-transform: rotate3d(0,1,0,90deg) translate3d(0,0,295px);
		transform: rotate3d(0,1,0,90deg) translate3d(0,0,295px);
		-webkit-backface-visibility: hidden;
		backface-visibility: hidden;
	}

	li .bk-left {
		height: 400px;
		-webkit-transform: rotate3d(0,1,0,-90deg);
		transform: rotate3d(0,1,0,-90deg);
	}

	li .bk-top {
		-webkit-transform: rotate3d(1,0,0,90deg);
		transform: rotate3d(1,0,0,90deg);
	}

	li .bk-bottom {
		-webkit-transform: rotate3d(1,0,0,-90deg) translate3d(0,0,390px);
		transform: rotate3d(1,0,0,-90deg) translate3d(0,0,390px);
	}

	/* Transform classes */

	li .bk-viewinside .bk-front {
		-webkit-transform: translate3d(0,0,20px) rotate3d(0,1,0,-160deg);
		transform: translate3d(0,0,20px) rotate3d(0,1,0,-160deg);
	}

	li .bk-book.bk-viewinside {
		-webkit-transform: translate3d(0,0,150px) rotate3d(0,1,0,0deg);
		transform: translate3d(0,0,150px) rotate3d(0,1,0,0deg);
	}

	li .bk-book.bk-viewback {
		-webkit-transform: translate3d(0,0,0px) rotate3d(0,1,0,180deg);
		transform: translate3d(0,0,0px) rotate3d(0,1,0,180deg);
	}

	/* Main colors and content */

	li .bk-page,
	li .bk-right,
	li .bk-top,
	li .bk-bottom {
		background-color: #fff;
	}

	li .bk-front > div {
		border-radius: 0 3px 3px 0;
		box-shadow:
			inset 4px 0 10px rgba(0, 0, 0, 0.1);
	}

	li .bk-front:after {
		content: '';
		position: absolute;
		top: 1px;
		bottom: 1px;
		left: -1px;
		width: 1px;
	}

	li .bk-cover:after,
	li .bk-back:after {
		content: '';
		position: absolute;
		top: 0;
		left: 10px;
		bottom: 0;
		width: 3px;
		background: #0000000f;
		box-shadow: 1px 0 3px #ffffff1a;
	}

	li .bk-back:after {
		left: auto;
		right: 10px;
	}

	.bk-content {
		position: absolute;
		top: 30px;
		left: 20px;
		bottom: 20px;
		right: 20px;
		padding: 30px;
		overflow: hidden;
		background: #fff;
		opacity: 0;
		pointer-events: none;
		-webkit-backface-visibility: hidden;
		backface-visibility: hidden;
		-webkit-transition: opacity 0.3s ease-in-out;
		transition: opacity 0.3s ease-in-out;
		cursor: default;
	}

	.bk-content-current {
		opacity: 1;
		pointer-events: auto;
	}

	.bk-content p {
		padding: 0 0 10px;
		-webkit-font-smoothing: antialiased;
		color: #000;
		font-size: 13px;
		line-height: 20px;
		text-align: justify;
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.bk-page nav {
		display: block;
		text-align: center;
		margin-top: 20px;
		position: relative;
		z-index: 100;
		cursor: pointer;
	}

	.bk-page nav span {
		display: inline-block;
		width: 20px;
		height: 20px;
		color: #aaa;
		background: #f0f0f0;
		border-radius: 50%;
	}
	
	/* Individual style & artwork */

	/* Book 1 */
	.book .bk-front > div,
	.book .bk-back,
	.book .bk-left,
	.book .bk-front:after {
		background-color: #CDDAD1;
	}
</style>